import { render, staticRenderFns } from "./TxnList.vue?vue&type=template&id=0b5ba534&scoped=true&"
import script from "./TxnList.vue?vue&type=script&lang=js&"
export * from "./TxnList.vue?vue&type=script&lang=js&"
import style0 from "./TxnList.vue?vue&type=style&index=0&id=0b5ba534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ba534",
  null
  
)

export default component.exports